/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CMADto,
  CreateCMAResponseDto,
  CreateEmptyCMADto,
  DuplicateCMAResponseDto,
  ListCMAResponseDto,
  LoadCMASubjectPropertyImagesOutput,
  PatchCMARequestDto,
  PropertyImageDto,
  ReorderComparablePropertiesRequest,
  SelectCMACoverImageDto,
  SelectComparablePropertyCoverImageRequestDto,
  SetEstimatedPriceRequestDto,
  UploadComparablePropertyImageResponseDto,
  UploadCoverPhotoResponseDto,
  UpsertCMASubjectPropertyByMlsIdRequestDto,
  UpsertCMASubjectPropertyByMlsIdResponseDto,
  UpsertComparablePropertyRequestDto,
} from '../models/index';
import {
    CMADtoFromJSON,
    CMADtoToJSON,
    CreateCMAResponseDtoFromJSON,
    CreateCMAResponseDtoToJSON,
    CreateEmptyCMADtoFromJSON,
    CreateEmptyCMADtoToJSON,
    DuplicateCMAResponseDtoFromJSON,
    DuplicateCMAResponseDtoToJSON,
    ListCMAResponseDtoFromJSON,
    ListCMAResponseDtoToJSON,
    LoadCMASubjectPropertyImagesOutputFromJSON,
    LoadCMASubjectPropertyImagesOutputToJSON,
    PatchCMARequestDtoFromJSON,
    PatchCMARequestDtoToJSON,
    PropertyImageDtoFromJSON,
    PropertyImageDtoToJSON,
    ReorderComparablePropertiesRequestFromJSON,
    ReorderComparablePropertiesRequestToJSON,
    SelectCMACoverImageDtoFromJSON,
    SelectCMACoverImageDtoToJSON,
    SelectComparablePropertyCoverImageRequestDtoFromJSON,
    SelectComparablePropertyCoverImageRequestDtoToJSON,
    SetEstimatedPriceRequestDtoFromJSON,
    SetEstimatedPriceRequestDtoToJSON,
    UploadComparablePropertyImageResponseDtoFromJSON,
    UploadComparablePropertyImageResponseDtoToJSON,
    UploadCoverPhotoResponseDtoFromJSON,
    UploadCoverPhotoResponseDtoToJSON,
    UpsertCMASubjectPropertyByMlsIdRequestDtoFromJSON,
    UpsertCMASubjectPropertyByMlsIdRequestDtoToJSON,
    UpsertCMASubjectPropertyByMlsIdResponseDtoFromJSON,
    UpsertCMASubjectPropertyByMlsIdResponseDtoToJSON,
    UpsertComparablePropertyRequestDtoFromJSON,
    UpsertComparablePropertyRequestDtoToJSON,
} from '../models/index';

export interface CMAControllerAddComparablePropertyRequest {
    id: string;
    mlsId: string;
}

export interface CMAControllerAddComprablePropertyImageRequest {
    id: string;
    mlsId: string;
    images: Array<Blob>;
}

export interface CMAControllerAddSubjectPropertyPhotoRequest {
    id: string;
    images: Array<Blob>;
}

export interface CMAControllerArchiveRequest {
    id: string;
}

export interface CMAControllerCloneRequest {
    id: string;
}

export interface CMAControllerCreateSimpleRequest {
    createEmptyCMADto: CreateEmptyCMADto;
}

export interface CMAControllerDeleteRequest {
    id: string;
}

export interface CMAControllerDeleteComparablePropertyImageRequest {
    id: string;
    mlsId: string;
    imgId: number;
}

export interface CMAControllerDeleteCoverPhotoRequest {
    id: string;
}

export interface CMAControllerGetRequest {
    id: string;
}

export interface CMAControllerGetInsightsRequest {
    id: string;
}

export interface CMAControllerListRequest {
    page: number;
    status?: string;
    orderBy?: string;
    limit?: number;
    agentId?: number;
}

export interface CMAControllerListMineRequest {
    page: number;
    status?: string;
    orderBy?: string;
    limit?: number;
}

export interface CMAControllerLoadSubjectPropertyImagesRequest {
    id: string;
}

export interface CMAControllerPatchRequest {
    id: string;
    patchCMARequestDto: PatchCMARequestDto;
}

export interface CMAControllerPublishRequest {
    id: string;
}

export interface CMAControllerRemoveComparablePropertyRequest {
    id: string;
    mlsId: string;
}

export interface CMAControllerRemoveSubjectPropertyPhotoRequest {
    id: string;
    imgId: number;
}

export interface CMAControllerReorderComparablePropertiesRequest {
    id: string;
    reorderComparablePropertiesRequest: ReorderComparablePropertiesRequest;
}

export interface CMAControllerSelectComparableCoverImageRequest {
    id: string;
    mlsId: string;
    selectComparablePropertyCoverImageRequestDto: SelectComparablePropertyCoverImageRequestDto;
}

export interface CMAControllerSelectCoverImageRequest {
    id: string;
    selectCMACoverImageDto: SelectCMACoverImageDto;
}

export interface CMAControllerSetEstimatedPriceRequest {
    id: string;
    setEstimatedPriceRequestDto: SetEstimatedPriceRequestDto;
}

export interface CMAControllerUnarchiveRequest {
    id: string;
}

export interface CMAControllerUploadCoverPhotoRequest {
    id: string;
    images: Array<Blob>;
}

export interface CMAControllerUpsertRequest {
    upsertCMASubjectPropertyByMlsIdRequestDto: UpsertCMASubjectPropertyByMlsIdRequestDto;
}

export interface CMAControllerUpsertComparablePropertyRequest {
    id: string;
    upsertComparablePropertyRequestDto: UpsertComparablePropertyRequestDto;
}

/**
 * 
 */
export class CMAApi extends runtime.BaseAPI {

    /**
     * - `id` is the CMA UUID - `mlsId` is \"mlsSource:mlsId\" format  
     * Adds a comparable property to a CMA by an MlsID
     */
    async cMAControllerAddComparablePropertyRaw(requestParameters: CMAControllerAddComparablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerAddComparableProperty().'
            );
        }

        if (requestParameters['mlsId'] == null) {
            throw new runtime.RequiredError(
                'mlsId',
                'Required parameter "mlsId" was null or undefined when calling cMAControllerAddComparableProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/comparable-properties/{mlsId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"mlsId"}}`, encodeURIComponent(String(requestParameters['mlsId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * - `id` is the CMA UUID - `mlsId` is \"mlsSource:mlsId\" format  
     * Adds a comparable property to a CMA by an MlsID
     */
    async cMAControllerAddComparableProperty(requestParameters: CMAControllerAddComparablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerAddComparablePropertyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerAddComprablePropertyImageRaw(requestParameters: CMAControllerAddComprablePropertyImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UploadComparablePropertyImageResponseDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerAddComprablePropertyImage().'
            );
        }

        if (requestParameters['mlsId'] == null) {
            throw new runtime.RequiredError(
                'mlsId',
                'Required parameter "mlsId" was null or undefined when calling cMAControllerAddComprablePropertyImage().'
            );
        }

        if (requestParameters['images'] == null) {
            throw new runtime.RequiredError(
                'images',
                'Required parameter "images" was null or undefined when calling cMAControllerAddComprablePropertyImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['images'] != null) {
            requestParameters['images'].forEach((element) => {
                formParams.append('images', element as any);
            })
        }


        let urlPath = `/comps/cmas/{id}/comparable-properties/{mlsId}/images`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"mlsId"}}`, encodeURIComponent(String(requestParameters['mlsId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UploadComparablePropertyImageResponseDtoFromJSON));
    }

    /**
     */
    async cMAControllerAddComprablePropertyImage(requestParameters: CMAControllerAddComprablePropertyImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UploadComparablePropertyImageResponseDto>> {
        const response = await this.cMAControllerAddComprablePropertyImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerAddSubjectPropertyPhotoRaw(requestParameters: CMAControllerAddSubjectPropertyPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyImageDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerAddSubjectPropertyPhoto().'
            );
        }

        if (requestParameters['images'] == null) {
            throw new runtime.RequiredError(
                'images',
                'Required parameter "images" was null or undefined when calling cMAControllerAddSubjectPropertyPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['images'] != null) {
            requestParameters['images'].forEach((element) => {
                formParams.append('images', element as any);
            })
        }


        let urlPath = `/comps/cmas/{id}/subject-property/images`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PropertyImageDtoFromJSON));
    }

    /**
     */
    async cMAControllerAddSubjectPropertyPhoto(requestParameters: CMAControllerAddSubjectPropertyPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyImageDto>> {
        const response = await this.cMAControllerAddSubjectPropertyPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerArchiveRaw(requestParameters: CMAControllerArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerArchive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/archive`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerArchive(requestParameters: CMAControllerArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerArchiveRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerCloneRaw(requestParameters: CMAControllerCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DuplicateCMAResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerClone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/clone`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DuplicateCMAResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerClone(requestParameters: CMAControllerCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DuplicateCMAResponseDto> {
        const response = await this.cMAControllerCloneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerCreateSimpleRaw(requestParameters: CMAControllerCreateSimpleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCMAResponseDto>> {
        if (requestParameters['createEmptyCMADto'] == null) {
            throw new runtime.RequiredError(
                'createEmptyCMADto',
                'Required parameter "createEmptyCMADto" was null or undefined when calling cMAControllerCreateSimple().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/create-simple`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmptyCMADtoToJSON(requestParameters['createEmptyCMADto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCMAResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerCreateSimple(requestParameters: CMAControllerCreateSimpleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCMAResponseDto> {
        const response = await this.cMAControllerCreateSimpleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerDeleteRaw(requestParameters: CMAControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerDelete(requestParameters: CMAControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerDeleteComparablePropertyImageRaw(requestParameters: CMAControllerDeleteComparablePropertyImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerDeleteComparablePropertyImage().'
            );
        }

        if (requestParameters['mlsId'] == null) {
            throw new runtime.RequiredError(
                'mlsId',
                'Required parameter "mlsId" was null or undefined when calling cMAControllerDeleteComparablePropertyImage().'
            );
        }

        if (requestParameters['imgId'] == null) {
            throw new runtime.RequiredError(
                'imgId',
                'Required parameter "imgId" was null or undefined when calling cMAControllerDeleteComparablePropertyImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/comparable-properties/{mlsId}/images/{imgId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"mlsId"}}`, encodeURIComponent(String(requestParameters['mlsId'])));
        urlPath = urlPath.replace(`{${"imgId"}}`, encodeURIComponent(String(requestParameters['imgId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerDeleteComparablePropertyImage(requestParameters: CMAControllerDeleteComparablePropertyImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerDeleteComparablePropertyImageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerDeleteCoverPhotoRaw(requestParameters: CMAControllerDeleteCoverPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerDeleteCoverPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/cover-photo`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerDeleteCoverPhoto(requestParameters: CMAControllerDeleteCoverPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerDeleteCoverPhotoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerGetRaw(requestParameters: CMAControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CMADto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CMADtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerGet(requestParameters: CMAControllerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CMADto> {
        const response = await this.cMAControllerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerGetInsightsRaw(requestParameters: CMAControllerGetInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerGetInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/insights`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerGetInsights(requestParameters: CMAControllerGetInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerGetInsightsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerListRaw(requestParameters: CMAControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCMAResponseDto>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling cMAControllerList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['agentId'] != null) {
            queryParameters['agentId'] = requestParameters['agentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCMAResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerList(requestParameters: CMAControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCMAResponseDto> {
        const response = await this.cMAControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerListMineRaw(requestParameters: CMAControllerListMineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCMAResponseDto>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling cMAControllerListMine().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/mine`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCMAResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerListMine(requestParameters: CMAControllerListMineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCMAResponseDto> {
        const response = await this.cMAControllerListMineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerLoadSubjectPropertyImagesRaw(requestParameters: CMAControllerLoadSubjectPropertyImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadCMASubjectPropertyImagesOutput>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerLoadSubjectPropertyImages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/subject-properties/images/load`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadCMASubjectPropertyImagesOutputFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerLoadSubjectPropertyImages(requestParameters: CMAControllerLoadSubjectPropertyImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadCMASubjectPropertyImagesOutput> {
        const response = await this.cMAControllerLoadSubjectPropertyImagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cMAControllerPatchRaw(requestParameters: CMAControllerPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerPatch().'
            );
        }

        if (requestParameters['patchCMARequestDto'] == null) {
            throw new runtime.RequiredError(
                'patchCMARequestDto',
                'Required parameter "patchCMARequestDto" was null or undefined when calling cMAControllerPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchCMARequestDtoToJSON(requestParameters['patchCMARequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerPatch(requestParameters: CMAControllerPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerPublishRaw(requestParameters: CMAControllerPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerPublish().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/publish`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async cMAControllerPublish(requestParameters: CMAControllerPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.cMAControllerPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * - `id` is the CMA UUID - `mlsId` is \"mlsSource:mlsId\" format  
     * Removes a comparable property from a CMA by an MlsID
     */
    async cMAControllerRemoveComparablePropertyRaw(requestParameters: CMAControllerRemoveComparablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerRemoveComparableProperty().'
            );
        }

        if (requestParameters['mlsId'] == null) {
            throw new runtime.RequiredError(
                'mlsId',
                'Required parameter "mlsId" was null or undefined when calling cMAControllerRemoveComparableProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/comparable-properties/{mlsId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"mlsId"}}`, encodeURIComponent(String(requestParameters['mlsId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * - `id` is the CMA UUID - `mlsId` is \"mlsSource:mlsId\" format  
     * Removes a comparable property from a CMA by an MlsID
     */
    async cMAControllerRemoveComparableProperty(requestParameters: CMAControllerRemoveComparablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerRemoveComparablePropertyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerRemoveSubjectPropertyPhotoRaw(requestParameters: CMAControllerRemoveSubjectPropertyPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerRemoveSubjectPropertyPhoto().'
            );
        }

        if (requestParameters['imgId'] == null) {
            throw new runtime.RequiredError(
                'imgId',
                'Required parameter "imgId" was null or undefined when calling cMAControllerRemoveSubjectPropertyPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/subject-property/images/{imgId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"imgId"}}`, encodeURIComponent(String(requestParameters['imgId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerRemoveSubjectPropertyPhoto(requestParameters: CMAControllerRemoveSubjectPropertyPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerRemoveSubjectPropertyPhotoRaw(requestParameters, initOverrides);
    }

    /**
     * - `id` is the CMA UUID - `order` is the ordered comparables
     * Udate the comparables order
     */
    async cMAControllerReorderComparablePropertiesRaw(requestParameters: CMAControllerReorderComparablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerReorderComparableProperties().'
            );
        }

        if (requestParameters['reorderComparablePropertiesRequest'] == null) {
            throw new runtime.RequiredError(
                'reorderComparablePropertiesRequest',
                'Required parameter "reorderComparablePropertiesRequest" was null or undefined when calling cMAControllerReorderComparableProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/comparable-properties/order`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderComparablePropertiesRequestToJSON(requestParameters['reorderComparablePropertiesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * - `id` is the CMA UUID - `order` is the ordered comparables
     * Udate the comparables order
     */
    async cMAControllerReorderComparableProperties(requestParameters: CMAControllerReorderComparablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerReorderComparablePropertiesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerSelectComparableCoverImageRaw(requestParameters: CMAControllerSelectComparableCoverImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerSelectComparableCoverImage().'
            );
        }

        if (requestParameters['mlsId'] == null) {
            throw new runtime.RequiredError(
                'mlsId',
                'Required parameter "mlsId" was null or undefined when calling cMAControllerSelectComparableCoverImage().'
            );
        }

        if (requestParameters['selectComparablePropertyCoverImageRequestDto'] == null) {
            throw new runtime.RequiredError(
                'selectComparablePropertyCoverImageRequestDto',
                'Required parameter "selectComparablePropertyCoverImageRequestDto" was null or undefined when calling cMAControllerSelectComparableCoverImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/comparable-property/{mlsId}/images/cover`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"mlsId"}}`, encodeURIComponent(String(requestParameters['mlsId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectComparablePropertyCoverImageRequestDtoToJSON(requestParameters['selectComparablePropertyCoverImageRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerSelectComparableCoverImage(requestParameters: CMAControllerSelectComparableCoverImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerSelectComparableCoverImageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerSelectCoverImageRaw(requestParameters: CMAControllerSelectCoverImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerSelectCoverImage().'
            );
        }

        if (requestParameters['selectCMACoverImageDto'] == null) {
            throw new runtime.RequiredError(
                'selectCMACoverImageDto',
                'Required parameter "selectCMACoverImageDto" was null or undefined when calling cMAControllerSelectCoverImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/subject-property/images/cover`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectCMACoverImageDtoToJSON(requestParameters['selectCMACoverImageDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerSelectCoverImage(requestParameters: CMAControllerSelectCoverImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerSelectCoverImageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerSetEstimatedPriceRaw(requestParameters: CMAControllerSetEstimatedPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerSetEstimatedPrice().'
            );
        }

        if (requestParameters['setEstimatedPriceRequestDto'] == null) {
            throw new runtime.RequiredError(
                'setEstimatedPriceRequestDto',
                'Required parameter "setEstimatedPriceRequestDto" was null or undefined when calling cMAControllerSetEstimatedPrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/estimated-price`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetEstimatedPriceRequestDtoToJSON(requestParameters['setEstimatedPriceRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerSetEstimatedPrice(requestParameters: CMAControllerSetEstimatedPriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerSetEstimatedPriceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerUnarchiveRaw(requestParameters: CMAControllerUnarchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerUnarchive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/unarchive`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cMAControllerUnarchive(requestParameters: CMAControllerUnarchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerUnarchiveRaw(requestParameters, initOverrides);
    }

    /**
     */
    async cMAControllerUploadCoverPhotoRaw(requestParameters: CMAControllerUploadCoverPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadCoverPhotoResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerUploadCoverPhoto().'
            );
        }

        if (requestParameters['images'] == null) {
            throw new runtime.RequiredError(
                'images',
                'Required parameter "images" was null or undefined when calling cMAControllerUploadCoverPhoto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['images'] != null) {
            requestParameters['images'].forEach((element) => {
                formParams.append('images', element as any);
            })
        }


        let urlPath = `/comps/cmas/{id}/cover-photo`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadCoverPhotoResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async cMAControllerUploadCoverPhoto(requestParameters: CMAControllerUploadCoverPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadCoverPhotoResponseDto> {
        const response = await this.cMAControllerUploadCoverPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches for a property using the given `mlsId` and sets it as the subject property for an existing CMA or creates a new CMA if the `id` parameter is null. - `mlsId` is required  - `id` is an optional UUID
     * Update or Create a CMA by a MlsID
     */
    async cMAControllerUpsertRaw(requestParameters: CMAControllerUpsertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpsertCMASubjectPropertyByMlsIdResponseDto>> {
        if (requestParameters['upsertCMASubjectPropertyByMlsIdRequestDto'] == null) {
            throw new runtime.RequiredError(
                'upsertCMASubjectPropertyByMlsIdRequestDto',
                'Required parameter "upsertCMASubjectPropertyByMlsIdRequestDto" was null or undefined when calling cMAControllerUpsert().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertCMASubjectPropertyByMlsIdRequestDtoToJSON(requestParameters['upsertCMASubjectPropertyByMlsIdRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpsertCMASubjectPropertyByMlsIdResponseDtoFromJSON(jsonValue));
    }

    /**
     * Searches for a property using the given `mlsId` and sets it as the subject property for an existing CMA or creates a new CMA if the `id` parameter is null. - `mlsId` is required  - `id` is an optional UUID
     * Update or Create a CMA by a MlsID
     */
    async cMAControllerUpsert(requestParameters: CMAControllerUpsertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpsertCMASubjectPropertyByMlsIdResponseDto> {
        const response = await this.cMAControllerUpsertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * - `id` is the CMA UUID - the body contains fields from the property that should be added as a comparable
     * Inserts or updates a comparable property into a CMA
     */
    async cMAControllerUpsertComparablePropertyRaw(requestParameters: CMAControllerUpsertComparablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cMAControllerUpsertComparableProperty().'
            );
        }

        if (requestParameters['upsertComparablePropertyRequestDto'] == null) {
            throw new runtime.RequiredError(
                'upsertComparablePropertyRequestDto',
                'Required parameter "upsertComparablePropertyRequestDto" was null or undefined when calling cMAControllerUpsertComparableProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/comps/cmas/{id}/comparable-properties`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertComparablePropertyRequestDtoToJSON(requestParameters['upsertComparablePropertyRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * - `id` is the CMA UUID - the body contains fields from the property that should be added as a comparable
     * Inserts or updates a comparable property into a CMA
     */
    async cMAControllerUpsertComparableProperty(requestParameters: CMAControllerUpsertComparablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cMAControllerUpsertComparablePropertyRaw(requestParameters, initOverrides);
    }

}
